import enLocale from 'element-ui/lib/locale/lang/en'
import roLocale from 'element-ui/lib/locale/lang/ro'

const messages = {
  en: {
    general: {
      search: 'Search',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      remove: 'Remove',
      save: 'Save',
      update: 'Update',
      cancel: 'Cancel',
      activate: 'activate',
      deactivate: 'deactivate',
      active: 'active',
      inactive: 'inactive',
      yes: 'Yes',
      no: 'No',
      success: 'Success',
      required: 'required',
      back: 'back',
      next: 'Next',
      finish: 'Finish',
      duplicate: 'Duplicate',
      select: 'Select',
      all: 'All',
      reset: 'Reset',
      export: 'Export',
      loadMore: 'Load More',
      showing: 'Showing {length} result(s)'
    },
    pages: {
      login: 'Login',
      register: 'Register',
      recoverPassword: 'Recover Password',
      resetPassword: 'Reset Password',
      dashboard: 'Dashboard',
      orderingManagement: 'Ordering Management',
      customerDetails: 'Customer Details',
      customers: 'Customers',
      orders: 'Orders',
      products: 'Products',
      catalog: 'Catalog',
      categories: 'Categories',
      productOptions: 'Product Options',
      marketing: 'Marketing',
      campaigns: 'Campaigns',
      offersSlider: 'Offers Slider',
      reports: 'Reports',
      feedback: 'Feedback',
      settings: 'Settings',
      logout: 'Logout'
    },
    ordersStatus: {
      AWAITING_TRANSPORT: 'Awaiting Transport',
      CANCELED: 'Canceled',
      DELIVERED: 'Delivered',
      DRAFT: 'Draft',
      NEW: 'New',
      NOT_DELIVERED: 'Not Delivered',
      PICKED_UP_BY_DELIVERY: 'Picked up for delivery',
      PROCESSING: 'Processing',
      PREPARED: 'Prepared',
      TRANSPORT: 'In transport'
    },
    ordersTypes: {
      GROUP: 'Group',
      SINGLE: 'Single'
    },
    paymentTypes: {
      CASH: 'Cash',
      CARD: 'Card'
    },
    paymentStatus: {
      notPaid: 'Not paid',
      paid: 'Paid',
      notOk: 'Declined'
    },
    campaignsModes: {
      AUTO: 'Auto',
      MANUAL: 'Manual'
    },
    campaignsNotificationTypes: {
      EMAIL: 'E-mail',
      PUSH: 'Push Notification'
    },
    days: {
      monday: 'monday',
      tuesday: 'tuesday',
      wednesday: 'wednesday',
      thursday: 'thursday',
      friday: 'friday',
      saturday: 'saturday',
      sunday: 'sunday'
    },
    gender: {
      selectGender: 'Select gender',
      male: 'male',
      female: 'female',
      Male: 'Male',
      Female: 'Female',
      Other: 'Other'
    },
    reportsAgesGroups: {
      selectAge: 'Select Age',
      '20': 'Under 20',
      'Under 20': 'Under 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      '50+': '50+',
      Unspecified: 'Unspecified'
    },
    deliveryTypes: {
      DELIVERY: 'Delivery',
      EAT_LOCATION: 'Eat on location',
      MEET_HALF: 'Meet me half way',
      PICK_UP: 'Pick-up'
    },
    couponsTypes: {
      FIXED: 'Fixed',
      PERCENTAGE: 'Percentage'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Fixed (included)',
      PERCENTAGE_INCLUDED: 'Percentage (included)',
      FIXED_EXCLUDED: 'Fixed (excluded)',
      PERCENTAGE_EXCLUDED: 'Percentage (excluded)'
    },
    productOptions: {
      checkbox: 'Allows selecting multiple options on the product',
      radio: 'Allows selecting only one option on the product'
    },
    validations: {
      areYouSureYouWantTo: 'Are you sure you want to ',
      areYouSure: 'Are you sure you want to update the status to ',
      wentWrong: 'Something went wrong, please try again later...',
      pictureSize: 'jpg/png files with a size less than 5MB ',
      pictureSizeExceed: 'Picture size can not exceed 5MB!',
      removePhoto: 'Please remove the current file in order to be able to add a new one',
      dataCouldNotBeSaved: 'Data could not be saved, please try again later.',
      passReq: 'Password field id required.',
      passMin: 'Password must be at least 6 characters.',
      passConf: 'Password and password confirmation do not match.',
      validPoinsNo: 'Please add a valid money amount and a comment.'
    },
    dashboard: {
      selectLocation: 'Select location:',
      tile1Title: 'New Orders',
      tile2Title: 'Total Orders',
      tile3Title: 'Revenue',
      tile4Title: 'Newly registered users',
      today: 'Today',
      orderChart: 'Orders',
      completed: 'Number of orders',
      canceled: 'Canceled',
      salesChart: 'Sales',
      salesIn: 'Sales in',
      top5Chart: 'Top 5 products',
      orderingChart: 'Ordering types',
      nrOfOrders: 'Number of orders'
    },
    customers: {
      noCustomer: 'No Customer Selected',
      single: 'customer',
      plural: 'customers',
      title: 'CUSTOMER DETAILS',
      pointsTitle: 'Customer Loyalty Points',
      currentPoints: 'Current Points',
      pointsAddTitle: 'Add Points',
      id: 'ID',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      gender: 'Gender',
      birth: 'Birth Day',
      location: 'Location',
      number: 'Number',
      dateCreated: 'Date Created',
      delivery: 'Deliery',
      type: 'Type',
      status: 'Status',
      total: 'Total',
      allTimeSale: 'All time sale',
      none: 'None',
      pointsLabel: 'Money spent',
      commentsLabel: 'Comment',
      pointsSuccess: 'Loyalty points added successfully.',
      pointsError: 'We cound not add the points to the customer.'
    },
    orders: {
      counterPerCustomer: 'Number of Orders',
      noOrders: 'No Order Selected',
      single: 'order',
      the_order: 'Order',
      plural: 'orders',
      status: 'Status',
      location: 'Location',
      updateStatus: 'Update Status',
      ordDetails: 'Order Details',
      date: 'Date',
      madeAt: 'Order made at',
      pickupTime: 'Delivery / Pick-up at',
      reservationTime: 'Reservation Time',
      reservationSeats: 'Reservation seats',
      rating: 'Rating',
      meetupLocation: 'Meet-up Location',
      ordLocation: 'Order Location',
      delivery: 'Deliery',
      type: 'Type',
      payment: 'Payment',
      name: 'Name',
      qty: 'Qty',
      unit: 'Unit Price',
      total: 'Total',
      totals_subtotals: 'Subtotal',
      totals_discount: 'Discount',
      totals_discount_loyalty_points: 'Discount from loyalty points',
      totals_grandtotal: 'Total',
      totals_shipping: 'Shipping',
      totals_tip: 'Tips',
      custComments: 'Customer Comment',
      adminComments: 'Admin Comment',
      custDetails: 'Customer Details',
      shipping: 'Shipping Address',
      billing: 'Billing Address',
      orderStatusSuccess: 'Order status updated successfully',
      orderCommnetSuccess: 'Order comment updated successfully',
      orderHourSuccess: 'Order delivery / pick-up time updated successfully',
      orderHourError: 'Prease provide a valid hour.',
      none: 'No Comment',
      at: 'at',
      filtersApplied: 'Filters applied - click on filter button to see more',
      customFilters: 'Custom filters applied',
      resetFilters: 'click here to reset and see live data'
    },
    catalogProd: {
      noProducts: 'No Product Selected',
      single: 'product',
      plural: 'products',
      generalDetails: 'General Details',
      name: 'Name',
      desc: 'Description',
      image: 'Image',
      category: 'Category',
      price: 'Price',
      taxes: 'Applied taxes',
      status: 'Status',
      posid: 'POS ID',
      allowUserComments: 'Allow user comments',
      validFromTo: 'Valid from - to',
      prodType: 'Product Type',
      singleType: 'single',
      groupType: 'group',
      rewardPoints: 'Reward points',
      moneySpent: 'Money to Points',
      numberOfYouNeedToSpend: 'Number of {currency} that the customer needs to spend to get a point.',
      points: 'points',
      soldWith: 'Sold with',
      pickAnOption: 'Pick an option',
      minNoSelected: 'Min no. selected',
      maxNoSelected: 'Max no. selected',
      optVal: 'Value',
      leaveEmpty: 'Leave empty or put 0 if option does not cost extra',
      prodDeleted: 'Product deleted successfully',
      prodAdded: 'Product added successfully',
      prodUpdated: 'Product updated successfully',
      prodPhotoError: 'We could not save the product photo, please try again later.',
      rewardPossibelValue: 'Possible values',
      errorOptions: 'Please check all the product options, some might not be filled in.'
    },
    catalogProdRewardsHints: {
      hint1: 'Leave empty to apply default value from settings',
      hint2: 'Put 0 to not apply reward program on this product',
      hint3: 'Add a positive value to override default value from settings'
    },
    catalogCateg: {
      single: 'category',
      plural: 'categories',
      name: 'Name',
      image: 'Image',
      displayType: 'Display Type',
      shortDescription: 'Short Description',
      validFromTo: 'Valid from - to',
      areYouSure: 'Are you sure you want to {label} this category?',
      categAdded: 'Category added successfully',
      categUpdated: 'Category updated successfully',
      categDeleted: 'Category deleted successfully',
      couldNotSave: 'We could not save the category photo, please try again later.'
    },
    catalogProdOpt: {
      single: 'Option',
      plural: 'options',
      new: 'New Option',
      name: 'Name',
      type: 'Type',
      value: 'Value',
      values: 'Values',
      posid: 'POS ID',
      optionSaved: 'Product options saved successfully.',
      areyouSure: 'Are you sure you want to delete this option?'
    },
    marketingCampaigns: {
      single: 'campaign',
      plural: 'campaigns',
      name: 'Name',
      image: 'Image',
      startEnd: 'Start - End Date',
      daysLeft: 'Days Left',
      status: 'Status',
      actions: 'Actions',
      send: 'Send',
      areYouSureNotif: 'Are you sure you want to send out the notifications?',
      notifSent: 'Notifications were sent.',
      campaignDeleted: 'Campaign deleted successfully.',
      areYouSureDelete: 'Are you sure you want to delete ',
      campaignAdded: 'Campaign added successfully',
      campaignUpdated: 'Campaign updated successfully',
      campaignPhotoError: 'We could not save the campaign photo, please try again later.',
      campaignDetails: 'Campaign Details',
      description: 'Description',
      maxDescription: '(max. 255 characters)',
      characters: 'characters',
      validFromTo: 'Valid from - to',
      notif: 'Notifications',
      model: 'Model',
      setHours: 'Set Hours',
      selectTime: 'Select time',
      chooseTarget: 'Choose target audience',
      gender: 'Gender',
      age: 'Age',
      city: 'City',
      location: 'Location',
      ordersAbove: 'Orders above',
      addCoupon: 'Add Coupon',
      applyTo: 'Apply to',
      value: 'Value',
      code: 'Code',
      generateCode: 'Generate Code',
      Products: 'Products',
      Shipping: 'Shipping',
      chooseCategProduct: 'Choose categories or products on which the coupon will apply:'
    },
    marketingOffers: {
      single: 'offer banner',
      plural: 'offer banners',
      title: 'Title',
      image: 'Image',
      linkType: 'Link Type',
      startEndDate: 'Start - End Date',
      actions: 'Actions',
      offerAdded: 'Offer banner added successfully.',
      offerUpdated: 'Offer banner updated successfully.',
      offerDeleted: 'Offer banner deleted successfully.',
      weCouldNot: 'We could not save the slider photo, please try again later.',
      validImg: 'Please add a valid image.',
      areYouSure: 'Are you sure you want to {label} this offer banner?',
      pageText: 'Page Text',
      pickCateg: 'Pick Category',
      pickProd: 'Pick Product',
      none: 'None'
    },
    marketingOffersTypes: {
      category: 'category',
      product: 'product',
      page: 'page'
    },
    reports: {
      trends: 'Trends',
      clients: 'Clients',
      products: 'Products',
      marketing: 'Marketing',
      today: 'Today',
      orderChart: 'Orders',
      completed: 'Completed',
      canceled: 'Canceled',
      salesChart: 'Sales',
      salesIn: 'Sales in',
      customersChart: 'Customers',
      appInstalls: 'App Installs',
      custWithAcc: 'Customers with account',
      top10Chart: 'Top 10 products',
      orderingChart: 'Ordering types',
      nrOfOrders: 'Number of orders',
      customersAge: 'Customers Age',
      customersGender: 'Customers Gender',
      name: 'Name',
      appInstalled: 'App Installed',
      gender: 'Gender',
      location: 'Location',
      email: 'Email',
      phone: 'Phone',
      totalAmount: 'Total Amount',
      itemsSold: 'Items Sold',
      campaign: 'Campaign',
      couponsTimesUsed: 'Coupons Times Used',
      revenue: 'Revenue',
      total: 'Total'
    },
    feedback: {
      sigle: 'feedback',
      type: 'Type',
      sentBy: 'Sent By',
      text: 'Text',
      seen: 'Seen',
      sentAt: 'Sent At'
    },
    feedbackTypes: {
      feedback: 'Feedback',
      issue: 'Issue',
      suggestion: 'Suggestion'
    },
    settings: {},
    settingsPages: {
      userSettings: 'User Settings',
      myProfile: 'My Profile',
      users: 'Users',
      general: 'General',
      companyDetails: 'Company Details',
      dateTime: 'Date & Time',
      currency: 'Currency',
      accounting: 'Accounting',
      tax: 'Tax',
      payment: 'Payment',
      orderingMng: 'Ordering Management',
      loyalty: 'Loyalty Program',
      push: 'Push Notifications',
      tips: 'Tips',
      subscription: 'Subscription',
      myPlan: 'My Plan',
      infoPages: 'Info Pages'
    },
    settingUsers: {
      single: 'user',
      fn: 'First Name',
      ln: 'Last Name',
      email: 'Email',
      username: 'Username',
      lang: 'Interface language',
      langMsg: 'This is the language in which you will see the administration area.',
      avatar: 'Avatar',
      role: 'Role',
      resetPass: 'Reset Password',
      password: 'Password',
      pass: 'Password',
      confPass: 'Confirm Password',
      userAdded: 'New user added successfully',
      userUpdated: 'User updated successfully',
      userPicError: 'We could not save the user avatar, please try again later.'
    },
    settingCompany: {
      title: 'Company',
      location: 'Location',
      name: 'Name',
      lang: 'Application language',
      bussLoc: 'Bussiness Location',
      deliveryLabels: 'Delivery types labels',
      pick_up: 'Pick-up',
      meet_half: 'Meet me half way',
      delivery: 'Delivery',
      eat_location: 'Eat on location',
      phone: 'Phone',
      street: 'Street',
      email: 'Email',
      city: 'City',
      country: 'Country',
      state: 'State',
      availableDaysHrs: 'AVAILABLE DAYS AND HOURS',
      from: 'from',
      to: 'to',
      preOrder: 'pre-order from',
      allowPreOrder: 'Allow Pre-order',
      userTaxes: 'USED TAXES',
      noTaxMsg: 'Info: You have made changes on taxes, don\'t forget to save them.',
      areYouSureDelete: 'Are you sure you want to delete this location? This action will also delete the ordering settings for this location.',
      areYouSureTax: 'Are you sure you want to remove this tax from taxes list? Don\'t forget to save the changes!',
      companyUpdated: 'Company data updated successfully.'
    },
    settingDateTime: {
      timezone: 'Timezone',
      timeFormat: 'Time format',
      dateFormat: 'Date format',
      saveMsg: 'Date & Time settings saved successfully'
    },
    settingCurrency: {
      currency: 'Shop currency',
      saveMsg: 'Currency data saved successfully'
    },
    settingTaxes: {
      single: 'Tax',
      name: 'Name',
      type: 'Type',
      amount: 'Amount',
      notice: 'Info: At "Tax" you only define a label name for the tax to be applied. To define the tax details such as value or type you need to go to',
      notice2: 'company details'
    },
    settingsPayment: {
      publicKey: 'Public key',
      privateKey: 'Private key'
    },
    settingsOrdering: {
      enabled: 'Enabled',
      paymentOptions: 'Payment Options',
      paymentOptionsErr: 'The payment option field is required.',
      waitingTime: 'Default waiting time',
      minimumOrderValue: 'Minimum order value',
      minutes: 'min',
      shippingCost: 'Shipping cost',
      shippingTax: 'Shipping tax',
      locations: 'Locations',
      street: 'Street',
      city: 'City',
      country: 'Country',
      state: 'State',
      availableDays: 'Available days and hours',
      availableDaysErr: 'The available days and hours option field is required.',
      notice: 'Please check the error in the enabled ordering methods tabs then try to save again the form',
      saveSuccess: 'Ordering details data saved successfully'
    },
    settingsInfoPages: {
      single: 'page',
      noPage: 'No pages added yet.',
      title: 'Page Title',
      content: 'Page Content',
      newPage: 'New Page',
      addedSuccess: 'Page saved successfully.',
      deletedSuccess: 'Page deleted successfully',
      deleteMsg: 'Are you sure you want to delete this page?',
      TERMS_CONDITIONS: 'Terms and Conditions',
      PRIVACY_POLICY: 'Privacy Policy',
      CONTACT_DETAILS: 'Contact Details'
    },
    settingsRewards: {
      single: 'point',
      plural: 'points',
      state: 'State',
      points: 'point(s)',
      moneySpent: 'Money Spent to points',
      pointsTo: 'Points to Money',
      numberOfcurrencyNeedToSpend: 'Amount of money client has to spend to earn 1 point.',
      numberOfpointsToReward: 'Amount of points client needs when he wants to pay using points.',
      rewardSuccess: 'Loyalty program data saved successfully'
    },
    settingsPushNotif: {
      order_new: 'New order message',
      order_completed_pickup: 'Completed order message - Pick-up',
      order_completed_meet: 'Completed order message - Meet me half way',
      order_completed_delivery: 'Completed order message - Delivery',
      order_completed_eat: 'Completed order message - Eat on location',
      order_canceled: 'Canceled order message',
      notifUpdated: 'Push notifications data saved successfully',
      preview: 'Preview',
      time: 'time',
      dateTime: 'date and time',
      persons: 'persons number',
      timePrev: '45 minutes',
      personsPrev: '3',
      dateTimePrev: 'Tuesday, February 15, 2019, at 6pm'
    },
    settingsTips: {
      tipsTaxes: 'Tips taxes',
      state: 'Use tips',
      tipsSuccess: 'Tips saved successfully'
    },
    settingsPlans: {
      plan1Title: 'Monthly',
      plan1Rate: '160€ / month',
      plan1Description: 'Get started with a monthly fixed fee, no matter the amount of sales you make through the app.',
      plan2Title: 'Sales percentage',
      plan2Rate: '10%',
      plan2Description: 'Pay as you sell. Chose the Sales Percentage and pay a monthly fee in relation with the amount you sell through the app.',
      current: 'Current subscription',
      switch: 'Switch'
    },
    checkbox: 'Allows selecting multiple options on the product',
    radio: 'Allows selecting only one option on the product',
    ...enLocale
  },
  ro: {
    general: {
      search: 'Caută',
      add: 'Adaugă',
      edit: 'Editează',
      delete: 'Șterge',
      remove: 'Elimină',
      save: 'Salvează',
      update: 'Actualizează',
      cancel: 'Anulează',
      activate: 'activează',
      deactivate: 'dezactivează',
      active: 'activ',
      inactive: 'inactiv',
      yes: 'Da',
      no: 'Nu',
      success: 'Succes',
      required: 'necesar',
      back: 'înapoi',
      next: 'Următorul',
      finish: 'Finalizează',
      duplicate: 'Duplică',
      select: 'Selectează',
      all: 'Toate',
      reset: 'Resetează',
      export: 'Exportă',
      loadMore: 'Încarcă mai mult',
      showing: '{length} rezultate afișate'
    },
    pages: {
      login: 'Logare',
      register: 'Înregistrare',
      recoverPassword: 'Recuperează Parola',
      resetPassword: 'Resetează Parola',
      dashboard: 'Panou comandă',
      orderingManagement: 'Gestionare Comenzi',
      customerDetails: 'Detalii Client',
      customers: 'Clienți',
      orders: 'Comenzi',
      products: 'Produse',
      catalog: 'Catalog',
      categories: 'Categorii',
      productOptions: 'Optiuni Produs',
      marketing: 'Marketing',
      campaigns: 'Campanii',
      offersSlider: 'Banner oferte',
      reports: 'Rapoarte',
      feedback: 'Feedback',
      settings: 'Setări',
      logout: 'Delogare'
    },
    ordersStatus: {
      AWAITING_TRANSPORT: 'În așteptarea transportului',
      CANCELED: 'Anulată',
      DELIVERED: 'Livrată',
      DRAFT: 'Ciornă',
      NEW: 'Nou',
      NOT_DELIVERED: 'Nelivrată',
      PICKED_UP_BY_DELIVERY: 'Preluată pentru livrare',
      PROCESSING: 'Procesată',
      PREPARED: 'Preparată',
      TRANSPORT: 'În transport'
    },
    ordersTypes: {
      GROUP: 'Grup',
      SINGLE: 'Individual'
    },
    paymentTypes: {
      CASH: 'Cash',
      CARD: 'Card'
    },
    paymentStatus: {
      notPaid: 'Neachitat',
      paid: 'Achitat',
      notOk: 'Refuzat'
    },
    campaignsModes: {
      AUTO: 'Auto',
      MANUAL: 'Manual'
    },
    campaignsNotificationTypes: {
      EMAIL: 'E-mail',
      PUSH: 'Notificări'
    },
    days: {
      monday: 'luni',
      tuesday: 'marți',
      wednesday: 'miercuri',
      thursday: 'joi',
      friday: 'vineri',
      saturday: 'sâmbătă',
      sunday: 'duminică'
    },
    gender: {
      selectGender: 'Selectează Genul',
      male: 'masculin',
      female: 'feminin',
      Male: 'Masculin',
      Female: 'Feminin',
      Other: 'Altul'
    },
    reportsAgesGroups: {
      selectAge: 'Selectează Vârsta',
      '20': 'Sub 20',
      'Under 20': 'Sub 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      '50+': '50+',
      Unspecified: 'Nespecificat'
    },
    deliveryTypes: {
      DELIVERY: 'Livare',
      EAT_LOCATION: 'Rezervă masă',
      MEET_HALF: 'Ne întâlnim la jumătate',
      PICK_UP: 'Ridicare comandă'
    },
    couponsTypes: {
      FIXED: 'Fix',
      PERCENTAGE: 'Procent'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Fix (inclus)',
      PERCENTAGE_INCLUDED: 'Procent (inclus)',
      FIXED_EXCLUDED: 'Fix (exclus)',
      PERCENTAGE_EXCLUDED: 'Procent (exclus)'
    },
    productOptions: {
      checkbox: 'Permite selectarea mai multor opțiuni pe produs',
      radio: 'Permite selectarea unei singure opțiuni pe produs'
    },
    validations: {
      areYouSureYouWantTo: 'Sigur că dorești modificarea ',
      areYouSure: 'Sigur dorești să actualizezi statusul ',
      wentWrong: 'A apărut o eroare, te rugăm să încerci mai târziu...',
      pictureSize: 'fișiere jpg/png cu o dimensiune mai mică de 5MB ',
      pictureSizeExceed: 'Dimeniunea pozelor nu poate depăși 5MB!',
      removePhoto: 'Te rugăm să ștergi documentele existente pentru a putea adăuga altele noi',
      dataCouldNotBeSaved: 'Datele nu au putut fi salvate, te rugăm să încerci mai târziu.',
      passReq: 'ID-ul câmpului de parolă este necesar.',
      passMin: 'Parola trebuie să conțină cel puțin 6 caractere.',
      passConf: 'Parola și confirmarea parolei nu corespund.',
      validPoinsNo: 'Te rugăm să adaugi o sumă valabilă de bani și un comentariu.'
    },
    dashboard: {
      selectLocation: 'Selectează locatia:',
      tile1Title: 'Comenzi Noi',
      tile2Title: 'Total Comenzi',
      tile3Title: 'Venituri',
      tile4Title: 'Utilizatori nou înregistrați',
      today: 'Azi',
      orderChart: 'Comenzi',
      completed: 'Număr de comenzi',
      canceled: 'Anulate',
      salesChart: 'Vânzări',
      salesIn: 'Vânzări în',
      top5Chart: 'Top 5 produse',
      orderingChart: 'Tipuri de comenzi',
      nrOfOrders: 'Număr de comenzi'
    },
    customers: {
      noCustomer: 'Nici un Client Selectat',
      single: 'client',
      plural: 'clienți',
      title: 'DETALII CLIENT',
      pointsTitle: 'Puncte Loialitate Client',
      currentPoints: 'Puncte Actuale',
      pointsAddTitle: 'Adaugă Puncte',
      id: 'ID',
      name: 'Nume',
      email: 'Email',
      phone: 'Telefon',
      gender: 'Gen',
      birth: 'Data nașterii',
      location: 'Locație',
      number: 'Număr',
      dateCreated: 'Data creare',
      delivery: 'Livrare',
      type: 'Tip',
      status: 'Status',
      total: 'Total',
      allTimeSale: 'Vânzări totale',
      none: 'Nici unul',
      pointsLabel: 'Bani cheluiți',
      commentsLabel: 'Comentariu',
      pointsSuccess: 'Puncte loialitate adăugate cu succes.',
      pointsError: 'Nu am putut adăuga punctele de loialitate clientului.'
    },
    orders: {
      counterPerCustomer: 'Număr Comenzi',
      noOrders: 'Nici o comandă Selectată',
      single: 'comandă',
      the_order: 'Comandă',
      plural: 'comenzi',
      status: 'Status',
      location: 'Locație',
      updateStatus: 'Actualizează Status',
      ordDetails: 'Detalii Comenzi',
      date: 'Data',
      madeAt: 'Comandă plasată la',
      pickupTime: 'Livrare / Ridicare la',
      reservationTime: 'Oră Rezervare',
      reservationSeats: 'Rezervare Locuri',
      rating: 'Evaluare',
      meetupLocation: 'Puncte întâlnire',
      ordLocation: 'Locație Comandă',
      delivery: 'Livrare',
      type: 'Tip',
      payment: 'Plată',
      name: 'Nume',
      qty: 'Cantitate',
      unit: 'Preț buc',
      total: 'Total',
      totals_subtotals: 'Subtotal',
      totals_discount: 'Discount',
      totals_discount_loyalty_points: 'Discount puncte loialitate',
      totals_grandtotal: 'Total',
      totals_shipping: 'Livrare',
      totals_tip: 'Bacșiș',
      custComments: 'Comentariu Client',
      adminComments: 'Comentariu Admin',
      custDetails: 'Detalii Clienți',
      shipping: 'Adresă Livrare',
      billing: 'Adresă Facturare',
      orderStatusSuccess: 'Statusul comenzii a fost actualizat cu succes',
      orderCommnetSuccess: 'Comentariul pe comandă a fost actualizat cu succes',
      orderHourSuccess: 'Timpul de livrare / ridicare comandă actualizat cu succes',
      orderHourError: 'Te rugăm să oferi o oră validă.',
      none: 'Nici un comentariu',
      at: 'la',
      filtersApplied: 'Filtre aplicate - apasă butonul de filtru pentru a vedea mai mult',
      customFilters: 'Filtre specifice aplicate',
      resetFilters: 'apasă aici pentru a reseta și a vedea datele actualizate'
    },
    catalogProd: {
      noProducts: 'Nici un produs selectat',
      single: 'produs',
      plural: 'produse',
      generalDetails: 'Detalii Generale',
      name: 'Nume',
      desc: 'Descriere',
      image: 'Imagine',
      category: 'Categorie',
      price: 'Preț',
      taxes: 'Taxe aplicate',
      status: 'Status',
      posid: 'POS ID',
      allowUserComments: 'Permite utilizatorilor să lase un mesaj',
      validFromTo: 'Valibil de la - până la',
      prodType: 'Tip Produs',
      singleType: 'indivuald',
      groupType: 'grup',
      rewardPoints: 'Puncte loialitate',
      moneySpent: 'Bani în Puncte',
      numberOfYouNeedToSpend: 'Suma de {currency} pe care clientul trebuie să o cheltuiască pentru a primi 1 punct.',
      points: 'puncte',
      soldWith: 'Vândut cu',
      pickAnOption: 'Alege o opțiune',
      minNoSelected: 'Nr. min selectat',
      maxNoSelected: 'Nr. max selectat',
      optVal: 'Valoare',
      leaveEmpty: 'Lasă gol sau pune 0 dacă opțiunea nu costă suplimentar',
      prodDeleted: 'Produs șters cu succes',
      prodAdded: 'Produs adăugat cu succes',
      prodUpdated: 'Produs actualizat cu succes',
      prodPhotoError: 'Nu am putut salva poza de produs, te rugăm să încerci mai târziu.',
      rewardPossibelValue: 'Posibile valori'
    },
    catalogProdRewardsHints: {
      hint1: 'Lasă gol pentru a putea aplica valoarea implicită din setări',
      hint2: 'Pune 0 pentru a nu aplica punctele de loialitate pentru acest produs',
      hint3: 'Adaugă o valoare pozivită pentru a trece peste valoarea implicită din setări'
    },
    catalogCateg: {
      single: 'categorie',
      plural: 'categorii',
      name: 'Nume',
      image: 'Imagine',
      displayType: 'Tip afișare',
      shortDescription: 'Scurtă Descriere',
      validFromTo: 'Valibil de la - până la',
      areYouSure: 'Ești sigur că vrei să {label} această categorie?',
      categAdded: 'Categorie adăugată cu succes',
      categUpdated: 'Categorie actualizată cu succes',
      categDeleted: 'Categorie ștearsă cu succes',
      couldNotSave: 'Poza de categorie nu a fost salvată, te rugăm să încerci mai târziu.'
    },
    catalogProdOpt: {
      single: 'Opțiune',
      plural: 'opțiuni',
      new: 'Opțiune Nouă',
      name: 'Nume',
      type: 'Tip',
      value: 'Valoare',
      values: 'Valori',
      posid: 'POS ID',
      optionSaved: 'Opțiune produs salvată cu succes.',
      areyouSure: 'Ești sigur că dorești să ștergi această opțiune?'
    },
    marketingCampaigns: {
      single: 'campanie',
      plural: 'campanii',
      name: 'Nume',
      image: 'Imagine',
      startEnd: 'Start - Sfârșit Perioadă',
      daysLeft: 'Zile rămase',
      status: 'Status',
      actions: 'Acțiuni',
      send: 'Trimite',
      areYouSureNotif: 'Ești sigur că dorești să trimiți aceste notificări?',
      notifSent: 'Notificările au fost trimise.',
      campaignDeleted: 'Campanie ștearsă cu succes.',
      areYouSureDelete: 'Ești sigur că vrei să ștergi ',
      campaignAdded: 'Campanie adăugată cu succes',
      campaignUpdated: 'Campanie actualizată cu succes',
      campaignPhotoError: 'Poza de campanie nu a fost salvată, te rugăm să încerci mai târziu.',
      campaignDetails: 'Detalii Campanie',
      description: 'Descriere',
      maxDescription: '(max. 255 caractere)',
      characters: 'caractere',
      validFromTo: 'Valibil de la - până la',
      notif: 'Notificări',
      model: 'Model',
      setHours: 'Setează Orele',
      selectTime: 'Alege Ora',
      chooseTarget: 'Alege publicul țintă',
      gender: 'Gen',
      age: 'Vârstă',
      city: 'Oraș',
      location: 'Locație',
      ordersAbove: 'Comenzi mai sus',
      addCoupon: 'Adaugă cupon',
      applyTo: 'Aplică la',
      value: 'Valoare',
      code: 'Cod',
      generateCode: 'Generează Cod',
      Products: 'Produse',
      Shipping: 'Livrare',
      chooseCategProduct: 'Alege caregoriile sau produsele pe care se va aplica cuponul:'
    },
    marketingOffers: {
      single: 'banner ofertă',
      plural: 'banner oferte',
      title: 'Titlu',
      image: 'Imagine',
      linkType: 'Tip Link',
      startEndDate: 'Valabil de la - până la',
      actions: 'Acțiuni',
      offerAdded: 'Banner ofertă adăugat cu succes.',
      offerUpdated: 'Banner ofertă actualizat cu succes.',
      offerDeleted: 'Banner ofertă șters cu succes.',
      weCouldNot: 'Poza pentru bannerul de oferă nu a fost salvată, te rugăm să încerci mai târziu.',
      validImg: 'Te rugăm să adaugi o imagine validă.',
      areYouSure: 'Ești sigur că dorești să {label} acest banner ofertă?',
      pageText: 'Text Pagină',
      pickCateg: 'Alege Categoria',
      pickProd: 'Alege Produsul',
      none: 'Nici unul'
    },
    marketingOffersTypes: {
      category: 'categorie',
      product: 'produs',
      page: 'pagină'
    },
    reports: {
      trends: 'Tendințe',
      clients: 'Clienți',
      products: 'Produse',
      marketing: 'Marketing',
      today: 'Azi',
      orderChart: 'Comenzi',
      completed: 'Finalizate',
      canceled: 'Anulate',
      salesChart: 'Vânzări',
      salesIn: 'Vânzări în',
      customersChart: 'Clienți',
      appInstalls: 'Aplicații Instalate',
      custWithAcc: 'Conturi clienți',
      top10Chart: 'Top 10 produse',
      orderingChart: 'Tip comandă',
      nrOfOrders: 'Număr comenzi',
      customersAge: 'Vârsta client',
      customersGender: 'Gen client',
      name: 'Nume',
      appInstalled: 'Aplicații Instalate',
      gender: 'Gen',
      location: 'Locație',
      email: 'Email',
      phone: 'Telefon',
      totalAmount: 'Total sumă',
      itemsSold: 'Produse vândute',
      campaign: 'Campanii',
      couponsTimesUsed: 'Număr cupoane utilizate',
      revenue: 'Venituri',
      total: 'Total'
    },
    feedback: {
      sigle: 'feedback',
      type: 'Tip',
      sentBy: 'Trimis prin',
      text: 'Text',
      seen: 'Văzut',
      sentAt: 'Trimis la'
    },
    feedbackTypes: {
      feedback: 'Feedback',
      issue: 'Problemă',
      suggestion: 'Sugestie'
    },
    settings: {},
    settingsPages: {
      userSettings: 'Setări utilizator',
      myProfile: 'Profilul meu',
      users: 'Utilizatori',
      general: 'General',
      companyDetails: 'Detalii Companie',
      dateTime: 'Data și Timp',
      currency: 'Monedă',
      accounting: 'Contabilitate',
      tax: 'Taxe',
      payment: 'Plata',
      orderingMng: 'Management Comenzi',
      loyalty: 'Program Loialitate',
      push: 'Notificări',
      tips: 'Bacșiș',
      subscription: 'Subscripție',
      myPlan: 'Abonamentul meu',
      infoPages: 'Pagini informative'
    },
    settingUsers: {
      single: 'utilizator',
      fn: 'Prenume',
      ln: 'Nume',
      email: 'Email',
      username: 'Nume utilizator',
      lang: 'Limbaj interfață',
      langMsg: 'Acesta este limbajul în care vei vedea panoul de administrare.',
      avatar: 'Avatar',
      role: 'Rol',
      resetPass: 'Resetează Parolă',
      password: 'Parolă',
      pass: 'Parolă',
      confPass: 'Confirmă Parolă',
      userAdded: 'Utilizator nou adăugat cu succes',
      userUpdated: 'Utilizator actualizat cu succes',
      userPicError: 'Avatarul utilizatorului nu a fost salvat, te rugăm să încerci mai târziu.'
    },
    settingCompany: {
      title: 'Companie',
      location: 'Locație',
      name: 'Nume',
      lang: 'Limbaj aplicație',
      bussLoc: 'Locație local',
      deliveryLabels: 'Status de livrare',
      pick_up: 'Ridicare comandă',
      meet_half: 'Ne întâlnim la jumătate',
      delivery: 'Livrare',
      eat_location: 'Rezervare masă',
      phone: 'Telefon',
      street: 'Stradă',
      email: 'Email',
      city: 'Oraș',
      country: 'Țară',
      state: 'Județ',
      availableDaysHrs: 'ZILE ȘI ORE DISPONIBILE',
      from: 'de la',
      to: 'până la',
      preOrder: 'pre-comandă de la',
      allowPreOrder: 'Permite Pre-comandă',
      userTaxes: 'TAXE UTILIZATE',
      noTaxMsg: 'Info: Ai făcut modificări la taxe, nu uita să le salvezi.',
      areYouSureDelete: 'Ești sigur că dorești să ștergi această locație? Această acțiune va șterge, de asemenea, setările de comandă pentru această opțiune.',
      areYouSureTax: 'Sigur dorești să elimini această taxă din lista impozitelor? Nu uita să salvezi modificările făcute!',
      companyUpdated: 'Informațiile despre companie au fost actualizate cu succes.'
    },
    settingDateTime: {
      timezone: 'Fus orar',
      timeFormat: 'Formatul de timp',
      dateFormat: 'Formatul de dată',
      saveMsg: 'Setările pentru dată și oră salvate cu succes'
    },
    settingCurrency: {
      currency: 'Moneda localului',
      saveMsg: 'Moneda localului salvată cu succes'
    },
    settingTaxes: {
      single: 'Taxă',
      name: 'Nume',
      type: 'Tip',
      amount: 'Cantitate',
      notice: 'Info: La "Taxe" definește doar un nume de etichetă pentru impozitul ce trebuie aplicat. Pentru a defini detaliile fiscale, cum ar fi valoarea sau tipul, trebuie să accesați ',
      notice2: 'detalii companie'
    },
    settingsPayment: {
      publicKey: 'Cheie publică',
      privateKey: 'Cheie privată'
    },
    settingsOrdering: {
      enabled: 'Activat',
      paymentOptions: 'Opțiuni de plată',
      paymentOptionsErr: 'Câmpul de opțiuni de plată este obligatoriu.',
      waitingTime: 'Timpul de așteptare implicit',
      minimumOrderValue: 'Valoarea minimă a comenzii',
      minutes: 'min',
      shippingCost: 'Cost livrare',
      shippingTax: 'Taxe livrare',
      locations: 'Locație',
      street: 'Stradă',
      city: 'Oraș',
      country: 'Țară',
      state: 'Județ',
      availableDays: 'Zile și ore disponibile',
      availableDaysErr: 'Câmpul pentru zilele și orele disponibile este obligatoriu.',
      notice: 'Verifică eroarea din câmpul modalităților de livrare activate, apoi încearcă să salvezi din nou formularul',
      saveSuccess: 'Datele despre detaliile comenzilor au fost salvate cu succes'
    },
    settingsInfoPages: {
      single: 'pagină',
      noPage: 'Nu s-au adăugat pagini încă.',
      title: 'Titlu Pagină',
      content: 'Conținut Pagină',
      newPage: 'Pagină nouă',
      addedSuccess: 'Pagină salvată cu succes.',
      deletedSuccess: 'Pagină ștearsă cu succes',
      deleteMsg: 'Ești sigur că dorești să ștergi această pagină?',
      TERMS_CONDITIONS: 'Termeni și Condiții',
      PRIVACY_POLICY: 'Politica de Confidențialitate',
      CONTACT_DETAILS: 'Date Contact'
    },
    settingsRewards: {
      single: 'punct',
      plural: 'puncte',
      state: 'Status',
      points: 'punct(e)',
      moneySpent: 'Bani cheltuiți în puncte',
      pointsTo: 'Puncte în Bani',
      numberOfcurrencyNeedToSpend: 'Suma de bani pe care clientul trebuie să o cheltuiască pentru a câștiga 1 punct.',
      numberOfpointsToReward: 'Suma de puncte de care clientul are nevoie atunci când vrea să plătească folosind puncte.',
      rewardSuccess: 'Datele programului de loialitate salvate cu succes'
    },
    settingsPushNotif: {
      order_new: 'Mesaj nou comandă',
      order_completed_pickup: 'Mesaj comandă finalizată - Ridicare comandă',
      order_completed_meet: 'Mesaj comandă finalizată - Ne întâlnim la jumătate',
      order_completed_delivery: 'Mesaj comandă finalizată - Livrare',
      order_completed_eat: 'Mesaj comandă finalizată - Rezervare masă',
      order_canceled: 'Mesaj comandă anulată',
      notifUpdated: 'Datele notificărilor prin mesaj salvate cu succes',
      preview: 'Previzualizare',
      time: 'oră',
      dateTime: 'data și ora',
      persons: 'numărul clientului',
      timePrev: '45 minute',
      personsPrev: '3',
      dateTimePrev: 'Marți, Februarie 15, 2019, la 18'
    },
    settingsTips: {
      tipsTaxes: 'Taxe bacșiș',
      state: 'Folosește bacșiș',
      tipsSuccess: 'Bacșiș salvat cu succes'
    },
    settingsPlans: {
      plan1Title: 'Lunar',
      plan1Rate: '160Euro / lună',
      plan1Description: 'Începe cu o taxă fixă lunară, indiferent de suma facturată prin aplicație.',
      plan2Title: 'Procentaj vânzari',
      plan2Rate: '10%',
      plan2Description: 'Plătești în funcție de cât vinzi. Alege procentul din vânzări și vei plăti o taxă lunară raportată doar la vânzările tale prin aplicație.',
      current: 'Subscripția actuală',
      switch: 'Schimbă'
    },
    checkbox: 'Permite selectarea mai multor opțiuni pe produs',
    radio: 'Permite selectarea unei singure opțiuni pe produs',
    ...roLocale
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/lang/lang.js